import { Stack, Tooltip, Typography } from "@mui/material";
import React from "react";
import "../../styles/global.scss";

const ProgressBar = ({ current, max }) => {
  const progress = Math.round((current / max) * 100);

  const Parentdiv = {
    height: "1em",
    width: "100%",
    maxWidth: "20em",
    border: `1px solid #FCD975`,
    backgroundColor: "white",
    borderRadius: 40,
    cursor: "pointer"
  };

  const Childdiv = {
    height: "100%",
    width: `${progress}%`,
    backgroundColor: "#FCD975",
    borderRadius: 40,
    textAlign: "center",
    fontFamily: `Hind", "Avenir", "Helvetica", arial`,
    color: "black",
  };

  return (
    <div className="progress-bar-container">
      <h5>{progress}% of tokens used</h5>
      <Tooltip
        title={
          <Stack direction="column">
            <Typography fontSize={14}>Used: {current}</Typography>
            <Typography fontSize={14}>Total: {max}</Typography>
          </Stack>
        }
        placement="bottom"
      >
        <div style={Parentdiv}>
          <div style={Childdiv}>&nbsp;</div>
        </div>
      </Tooltip>
    </div>
  );
};

export default ProgressBar;
